import { createContext, useContext, useState, ReactNode } from 'react';

export type FinixEnvironment = 'sandbox' | 'live';

interface FinixEnvironmentContextType {
  environment: FinixEnvironment;
  setEnvironment: (environment: FinixEnvironment) => void;
}

export const FinixEnvironmentContext =
  createContext<FinixEnvironmentContextType>({
    environment:
      (import.meta.env.VITE_FINIX_DEFAULT_ENVIRONMENT as FinixEnvironment) ??
      'sandbox',
    setEnvironment: () => {},
  });

interface FinixEnvironmentProviderProps {
  children: ReactNode;
}

export const FinixEnvironmentProvider: React.FC<
  FinixEnvironmentProviderProps
> = ({ children }) => {
  const [environment, setEnvironment] = useState<FinixEnvironment>(
    (import.meta.env.VITE_FINIX_DEFAULT_ENVIRONMENT as FinixEnvironment) ??
      'sandbox',
  );

  return (
    <FinixEnvironmentContext.Provider value={{ environment, setEnvironment }}>
      {children}
    </FinixEnvironmentContext.Provider>
  );
};

export const useFinixEnvironment = () => {
  const context = useContext(FinixEnvironmentContext);
  if (!context) {
    throw new Error(
      'useFinixEnvironment must be used within a FinixEnvironmentProvider',
    );
  }
  return context;
};
